import React, {useState} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {StyleSheet, Text, View, Image} from 'react-native';
import { NewTrainInfo} from '../NewListing/Components/NewTrainInfo';
import {colors} from '@mmt/legacy-commons/Styles/globalStyles';
import { AvailabilitySubscription } from '../TravelerDetails/Components/AvailabilitySubscription';
import {getColorBasedOnAvailabilityType} from '../NewListing/Components/AvailabilityCard';

import {
  REVIEW_PAGE_CONST,
  TRAVELLER_DETAILS,
  TRAVELLER_CONST,
} from '../../Utils/RailsConstant';
import TouchableRipple from '@mmt/legacy-commons/Common/Components/TouchableRipple';
import {getClassType} from "../Types/ClassType";
import {availabilityTypeColors} from "../../Utils/paymentUtils";
import { _label } from '../../vernacular/AppLanguage';
import {fontStyle,getLineHeight} from "../../vernacular/VernacularUtils";
import { trackClickEventProp61 } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { TATKAL_ALERT_STATUS } from '../ScheduleTatkalTravelerPage/constants/ScheduleTatkalTravelerPageConstants';
import LinearGradient from 'react-native-linear-gradient';

const trainHeader = StyleSheet.create({
  container: {flexDirection: 'column', marginTop: 10},
  box: {flexDirection: 'column'},
  name: {
    fontSize: 16, color: colors.black, marginBottom: 2
  },
  number: {
    fontSize: 16, color: colors.lightTextColor, marginBottom: 6
  },
  selectedClass: {
    fontSize: 12, color: colors.black, marginBottom: 6
  },
  availabilityStatus: {
    fontSize: 12,  color: colors.black, marginBottom: 6
  },
  availability: {fontSize: 16, marginBottom: 6},
  quota: {fontSize: 12,  color: colors.lightTextColor},
  separator: {
    height: 0.5,
    borderColor: colors.lightGrey,
    borderWidth: 0.5,
    marginTop: 12
  },
  lastUpdated: {
    fontSize: 12,
    color: colors.lightTextColor
  },
  bookingInfoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  availabilityText: {
    fontWeight: '700',
    fontSize: 14,
    color: colors.defaultTextColor,
  },
  headerContainer: {
    marginBottom: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  marginHorizontal: {
    marginHorizontal: 6,
  },
  trainInfoItems: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  infoContainer: {
    marginTop: 10,
  },
  marginBottom0: {
    marginBottom: 0
  },
  fontWeight700: {
    fontWeight: '700'
  },
  availabilityStatusCard: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  tatkalAlertText: {
    color: colors.white,
    fontSize: 10,
    fontWeight: '700',
  },
  tatkalAlertCard: {
    backgroundColor: colors.goldenYellow14,
    borderRadius: 8,
    marginTop: 3,
    paddingHorizontal: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const bookBJStyle = StyleSheet.create({
  separator: {
    height: 0.5,
    borderColor: colors.lightGrey,
    borderWidth: 0.5,
    marginTop: 12,
    marginBottom: 14,
    borderRadius: 0.5,
    borderStyle: 'dashed'
  }
})

const toShowQuota = (quota) => {
  const quotaToShow = ['TQ', 'LD'];
  let toShow = false;
  quotaToShow.forEach((value) => {
    if (value == quota.code) { toShow = true; }
  });
  return toShow;
};

export const TrainNameAndNumber = (props) => {
  const {
    trainName,
    trainNumber,
    id
  } = props;

  return (
    <View style={trainHeader.container}>
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        <Text style={[trainHeader.name, fontStyle("black"), getLineHeight(16)]} testID={`${id}_trainName`}>{getTrainName(trainName.toLowerCase())}</Text>
        <Text style={[trainHeader.number, fontStyle("regular"), getLineHeight(16)]} testID={`${id}_trainNumber`}>{`#${trainNumber}`}</Text>
      </View>
    </View>
  );
};

TrainNameAndNumber.propTypes = {
  trainName: PropTypes.string,
  trainNumber: PropTypes.string
};

TrainNameAndNumber.defaultProps = {
  trainName: '',
  trainNumber: ''
};

export const TrainBookingInfo = (props) => {
  const {
    selectedQuota,
    classValue,
    selectedAvlStatus,
    showBoardingStationChange,
    availabilityObject,
    selectedTrainInfo,
    page,
    id
  } = props;
  let availabilityStyle;
  if (!isEmpty(availabilityObject)) {
    availabilityStyle = getColorBasedOnAvailabilityType(availabilityObject.availablityType);
  }
  let lastUpdatedOn = '';

  if(selectedTrainInfo && selectedTrainInfo.tbsAvailability) {
    const selectedTrainAvailibility = selectedTrainInfo.tbsAvailability.filter(x => x.classType === classValue.code && x.quota === selectedQuota.id);
    if (selectedTrainAvailibility && selectedTrainAvailibility.length > 0) {
      lastUpdatedOn = selectedTrainAvailibility[0].lastUpdatedOn;
    }
  }
  if (page == REVIEW_PAGE_CONST) {
    lastUpdatedOn = _label("updated_just_now");
  }
  if (selectedTrainInfo && selectedTrainInfo.lastUpdatedOn) {
    lastUpdatedOn = selectedTrainInfo.lastUpdatedOn;
  }
  const trainNumber = selectedTrainInfo?.trainNumber;
  const bookinginfoforReviewPage = page.toLowerCase() === REVIEW_PAGE_CONST.toLowerCase();

  return (
    <View style={trainHeader.bookingInfoContainer}>
      {bookinginfoforReviewPage
        ? (<View style={{ width: '100%' }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={[trainHeader.selectedClass, fontStyle("bold")]} testID={`${id}_selectedClass`}>{_label(classValue.value, { uppercase: true })}</Text>
              {selectedAvlStatus &&
                <Text style={[trainHeader.availabilityStatus, fontStyle("bold")]} testID={`${id}_availabilityStatus`}>{availabilityObject.prettyPrintingAvailablityStatus || selectedAvlStatus}</Text>
              }
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={[trainHeader.quota, fontStyle("regular"), getLineHeight(12)]} testID={`${id}_quota`}>{ _label(selectedQuota.text) }</Text>
              <Text style={[trainHeader.quota, fontStyle("regular"), getLineHeight(12)]} testID={`${id}_lastUpdatedOn`}>{lastUpdatedOn}</Text>
            </View>
          </View>)
        : (<>
            <View style={trainHeader.trainInfoItems}>
              <Text style={[trainHeader.selectedClass, trainHeader.marginBottom0, fontStyle("regular")]}>#{trainNumber}</Text>
              <Text style={trainHeader.marginHorizontal}>|</Text>
              <Text style={[trainHeader.selectedClass, trainHeader.marginBottom0, fontStyle("regular")]} testID={`${id}_selectedClass`}>{_label(classValue.code, { uppercase: true })}</Text>
              <Text style={trainHeader.marginHorizontal}>|</Text>
              <Text style={[trainHeader.selectedClass, trainHeader.marginBottom0, fontStyle("regular")]}>{_label(selectedQuota.code)}</Text>
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={[trainHeader.quota, fontStyle("regular")]}>{lastUpdatedOn}</Text>
            </View>
          </>)
      }
    </View>
  );
};

export const ClassAndAvailInfo = (props) => {
  const {
    journeyClass,
    lastUpdatedOn,
    seatsAvailability: selectedAvlStatus,
    availabilityType,
    prettyPrintingAvailabilityStatus,
    totalFare: price,
  } = props;

  let availabilityStyle;
  if (!isEmpty(availabilityType)) {
    availabilityStyle = getColorBasedOnAvailabilityType(availabilityType);
  }
  const availabilityColorCode = (availabilityTypeColors[availabilityType] || '#000000');

  return (
    <View>
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        <View>
          <Text style={[trainHeader.selectedClass, fontStyle("bold"), getLineHeight(12)]}>{_label(getClassType(journeyClass).value, { uppercase: true })}</Text>
          { selectedAvlStatus &&
          <Text style={[trainHeader.availabilityStatus, fontStyle("bold"),
            {color: availabilityColorCode}, getLineHeight(12)]}>{prettyPrintingAvailabilityStatus || selectedAvlStatus}</Text>
          }
        </View>
        <View style={{alignItems: 'flex-end'}}>
          <Text style={{fontSize: 16, color: colors.black, ...fontStyle("black"), ...getLineHeight(16)}}>₹{price}</Text>
        </View>
      </View>
      <View><Text style={[trainHeader.lastUpdated, fontStyle("regular"), getLineHeight(12)]}>{lastUpdatedOn || '' }</Text></View>
    </View>
  );
};

export const getTrainName = (trainName) => {
  const exp = trainName?.split(' ');
  let key = '';
  exp?.forEach((ch) => {
    key += `${ch.charAt(0).toUpperCase() + ch.slice(1)} `;
  });
  return key;
};

const JourneyInfo = ({trainData, boardingStationList, id}) => (
  <NewTrainInfo style={{marginBottom: 20}} trainData={trainData} id={id} />
);

export const JourneyCardForReviewPage = (props) => {
  const {
    trainData, classValue, selectedQuota, selectedAvlStatus, boardingStationList, showBoardingStationChange, onAvailabilityLayout,
    availabilityObject, selectedTrainInfo, page, id
  } = props;

  const [viewDetails, toggleViewDetails] = useState(false);

  const onPressHandler = () => {
    const val = viewDetails ? 'hidedetails' : 'moredetails'
    const mapping = {
      [TRAVELLER_DETAILS]: TRAVELLER_CONST,
      [REVIEW_PAGE_CONST]: REVIEW_PAGE_CONST.toLowerCase(),
    }
    trackClickEventProp61(page,`mob_rail_${mapping[page]}_booking_${val}`)
    toggleViewDetails(!viewDetails);
  }

  return (
    <View style={{ marginBottom: 10 }} testID={id}>
      { trainData &&
        <TrainNameAndNumber
          trainName={trainData.trainName}
          trainNumber={trainData.trainNumber}
          id={id}
        />
      }
      { viewDetails && classValue && selectedQuota && selectedAvlStatus &&
      <TrainBookingInfo
        classValue={classValue}
        selectedQuota={selectedQuota}
        selectedTrainInfo={selectedTrainInfo}
        selectedAvlStatus={selectedAvlStatus}
        showBoardingStationChange={showBoardingStationChange}
        availabilityObject={availabilityObject}
        page={page}
        id={id}
      />
      }
      { viewDetails &&
      <View style={{marginTop: 12, marginBottom: 20}} onLayout={onAvailabilityLayout}>
        <JourneyInfo trainData={trainData} boardingStationList={boardingStationList} id={id}/>
      </View> }
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        <View>
          {
            !viewDetails && classValue && selectedQuota && selectedAvlStatus &&
            <View>
              <Text style={{...fontStyle("regular"), fontSize: 12, color: '#000000', paddingTop: 3 }}>
                { `${_label(classValue.value, { uppercase: true })}  |  `}
                { selectedAvlStatus &&
                <Text >
                  {availabilityObject.prettyPrintingAvailablityStatus || selectedAvlStatus}
                </Text> }
                { toShowQuota(selectedQuota) && `  |  ${_label(selectedQuota.text)}`}
              </Text>
            </View>
          }
        </View>
        <TouchableRipple onPress={() => onPressHandler()}>
          <View style={{ flexDirection: 'row' }} testID={`${props?.id}_viewDetailsButton`}>
            <Text style={{...fontStyle("bold"), fontSize: 12, color: '#008cff'}}>
              {viewDetails ? _label("hide_details") : _label("view_details")}
            </Text>
            <Image
              source={require('@mmt/legacy-assets/src/ic_arrow_blue_down.webp')}
              style={[{width: 20, height: 20}, viewDetails ? {transform: [{rotate: '180deg'}]} : {}]}
            />
          </View>
        </TouchableRipple>
      </View>
      <View style={trainHeader.separator} />
    </View>
  )
};

const styles = StyleSheet.create({
  departText: {
    fontSize: 14, fontWeight: 'bold',  color: colors.black
  },
  duration: {
    fontSize: 12,  color: colors.defaultTextColor, marginBottom: 10
  },
  durationWithoutMargin: {
    fontSize: 12,  color: colors.defaultTextColor
  },
  arrivalText: {
    fontSize: 14, fontWeight: 'bold', color: colors.black
  },
  circle: {
    height: 6, width: 6, borderWidth: StyleSheet.hairlineWidth * 1, borderRadius: 90, borderColor: colors.lightTextColor
  },
  line: {
    flex: 1, borderWidth: StyleSheet.hairlineWidth * 1, alignSelf: 'center', borderColor: colors.lightTextColor
  },
  frmStnCode: {
    fontSize: 14, fontWeight: 'bold', color: colors.black
  },
  frmStnName: {
    fontSize: 12, marginBottom: 10, color: colors.defaultTextColor
  },
  trainStops: {fontSize: 12, color: colors.defaultTextColor, marginBottom: 10},
  toStnCode: {
    fontSize: 14, fontWeight: 'bold',  color: colors.black
  },
  toStnName: {fontSize: 12, color: colors.defaultTextColor}
});

const TatkalAlertCard = () => (
  <LinearGradient
    style={trainHeader.tatkalAlertCard}
    colors={[colors.goldenYellow14, colors.goldenYellow15]}
    start={{ x: 0, y: 0 }}
    end={{ x: 0, y: 1 }}
  >
    <Text style={trainHeader.tatkalAlertText}>
      {TATKAL_ALERT_STATUS}
    </Text>
  </LinearGradient>
);

export const JourneyDetailsCard = (props) => {
  const {
    trainData, classValue, selectedQuota, selectedAvlStatus, boardingStationList, showBoardingStationChange, onAvailabilityLayout,
    availabilityObject, selectedTrainInfo, page, id
  } = props;

  const journeyDetailsforReviewPage = page.toLowerCase() === REVIEW_PAGE_CONST.toLowerCase();

  return (
    <View style={trainHeader.infoContainer} testID={id}>
      {journeyDetailsforReviewPage
        ? (<JourneyCardForReviewPage
          id={`${this.props?.id}_journeyDetailsForReviewPage`}
          trainData={selectedTrainInfo}
          selectedAvlStatus={selectedAvlStatus}
          selectedQuota={selectedQuota}
          classValue={classValue}
          selectedTrainInfo={selectedTrainInfo}
          boardingStationList={boardingStationList}
          showBoardingStationChange={showBoardingStationChange}
          onAvailabilityLayout={onAvailabilityLayout}
          availabilityObject={availabilityObject}
          page={page}
        />)
        : (<View>
          <View style={[trainHeader.container, trainHeader.headerContainer]}>
            <Text style={[trainHeader.name, fontStyle("black"), trainHeader.fontWeight700]} testID={`${id}_trainName`}>{getTrainName(trainData?.trainName?.toLowerCase())}</Text>
            <Text style={[trainHeader.availabilityText, fontStyle("bold")]}>{availabilityObject?.prettyPrintingAvailablityStatus || selectedAvlStatus}</Text>
          </View>
          {classValue && selectedQuota && selectedAvlStatus &&
            <TrainBookingInfo
              classValue={classValue}
              selectedQuota={selectedQuota}
              selectedTrainInfo={selectedTrainInfo}
              selectedAvlStatus={selectedAvlStatus}
              showBoardingStationChange={showBoardingStationChange}
              availabilityObject={availabilityObject}
              page={page}
              id={id}
            />
          }
          <View style={trainHeader.separator} />
          <View style={{ marginTop: 12 }} onLayout={onAvailabilityLayout}>
            <JourneyInfo trainData={trainData} boardingStationList={boardingStationList} id={id} />
          </View>
          {props.showAvailSubscrnWidget && <AvailabilitySubscription />}
          <View style={trainHeader.separator} />
        </View>
        )
      }
    </View>
  );
};

export const JourneyDetailsCardForBJ = (props) => {
  const {
    trainData = {},
    seatsAvailability,
    journeyClass,
    journeyQuota,
    totalFare,
    availabilityType,
    prettyPrintingAvailabilityStatus,
  } = props;

  return (
    <View>
      <TrainNameAndNumber
        trainName={trainData.trainName}
        trainNumber={trainData.trainNumber}
      />
      <View style={{marginTop: 12, marginBottom: 20}} >
        <JourneyInfo trainData={trainData} />
      </View>
      <View style={bookBJStyle.separator} />
      <ClassAndAvailInfo
        seatsAvailability={seatsAvailability}
        journeyClass={journeyClass}
        journeyQuota={journeyQuota}
        totalFare={totalFare}
        availabilityType={availabilityType}
        prettyPrintingAvailabilityStatus={prettyPrintingAvailabilityStatus}
        lastUpdatedOn={trainData.lastUpdatedOn}
      />
    </View>
  );
};
